import axios from 'axios';
// 引入QS在post时将参数序列化
import QS from 'qs';
// 引入封装组件
// import { util } from "../utils/global";

// 请求拦截 准备设置统一token 
// 添加请求拦截器
axios.interceptors.request.use(function (config) {
    // 将token给到一个前后台约定好的key中，作为请求发送
    if(config.url.indexOf("/park/getBusiness") != -1) {
        config.url = "https://g.zaztservice.com/park-pay" + config.url;
    } else if (config.url.indexOf("confirmOrder") != -1) {//  http://192.168.0.87:8071/
        // config.url = "https://shop.hengbo.top" + config.url;
        config.url = "https://g.zaztservice.com/park-shop/pc/" + config.url;
    } else {
        config.url = "https://g.zaztservice.com/park-shop/" + config.url;
    }
    if (config.method === 'post' && config.url.indexOf("getCarInLikePlate") == -1) {
        config.data = QS.stringify(config.data);
    }
    return config
}, function (error) {
    // Do something with request error
    return Promise.reject(error)
})

// 响应拦截器
axios.interceptors.response.use(function (res) {
    // 对响应返回情况进行提示封装
    var data = res.data;
    return data;
}, function (error) {
    // 对响应错误做点什么
    return false;
});

export default axios;


// WEBPACK FOOTER //
// ./src/request/axios.js